import React, { useContext, useMemo } from 'react';
import { MultiScreenController } from '../controllers/MultiScreenController';

const MultiScreenControllerContext = React.createContext<MultiScreenController | undefined>(undefined);

export function useMultiScreenController() {
    return useContext(MultiScreenControllerContext);
}

function WithMultiScreenController(props: React.PropsWithChildren<{}>) {
    const { children } = props;

    const controller = useMemo(() => new MultiScreenController(), []);

    return (
        <MultiScreenControllerContext.Provider value={controller}>
            {children}
        </MultiScreenControllerContext.Provider>
    );
}

export function withMultiScreenController(node: JSX.Element) {
    return <WithMultiScreenController>{node}</WithMultiScreenController>;
}
